module.exports = __webpack_public_path__ + "img/form-lower-title-desktop.01292248.png";